export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as gendersKey, initialState as gendersInitialState, State as GendersState } from './reducer';

export {
  getData as gendersGetData,
  getError as gendersGetError,
  getLoading as gendersGetLoading,
  mapData as gendersMapData,
} from './selectors';
